// extracted by mini-css-extract-plugin
module.exports = {"select":"phoneinput_select__fmsQl"};